// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__mSTOa","copy":"Home_copy__QCNjj","image":"Home_image__aq4oT"};